module.exports = __webpack_public_path__ + "static/media/close-icon-red.b048861c.svg";